import _styled from "styled-components";
import { Toast as FlowBiteToast } from 'flowbite-react';
import { CheckIcon } from '@heroicons/react/24/outline';
import InteractiveToast from './toast.interactive';
import { Alert } from '../alert';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Toast = function Toast(_ref) {
  var message = _ref.message,
      _ref$visible = _ref.visible,
      visible = _ref$visible === void 0 ? false : _ref$visible,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'success' : _ref$type,
      _ref$ui = _ref.ui,
      ui = _ref$ui === void 0 ? 'simple' : _ref$ui,
      title = _ref.title,
      _ref$position = _ref.position,
      position = _ref$position === void 0 ? 'top' : _ref$position;
  return visible ? /*#__PURE__*/_jsx(ToastStyled, {
    type: type,
    position: position,
    ui: ui,
    children: ui === 'interactive' ? /*#__PURE__*/_jsx(InteractiveToast, {
      type: type,
      message: message,
      title: title
    }) : ui === 'alert' ? /*#__PURE__*/_jsx(Alert, {
      variant: type,
      text: message
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(IconWrapper, {
        children: /*#__PURE__*/_jsx(CheckIconStyled, {})
      }), /*#__PURE__*/_jsx(ToastMessage, {
        children: message
      }), /*#__PURE__*/_jsx(FlowBiteToast.Toggle, {})]
    })
  }) : null;
};
export default Toast;

var ToastStyled = /*#__PURE__*/_styled(FlowBiteToast).withConfig({
  displayName: "toastprimary__ToastStyled",
  componentId: "sc-1anczyn-0"
})(["", " ", " ", " ", " ", ""], {
  "position": "fixed",
  "right": "6rem",
  "zIndex": "99",
  "width": "100%"
}, function (_ref2) {
  var position = _ref2.position;
  return position === 'top' ? {
    "top": "6rem"
  } : {};
}, function (_ref3) {
  var position = _ref3.position;
  return position === 'bottom' ? {
    "bottom": "6rem"
  } : {};
}, function (_ref4) {
  var type = _ref4.type,
      ui = _ref4.ui;
  return ui !== 'alert' ? typeStyleMap[type] : {};
}, function (_ref5) {
  var ui = _ref5.ui;
  return ui === 'alert' ? {
    "bottom": "1rem",
    "right": "50%",
    "width": "fit-content",
    "minWidth": "312px",
    "--tw-translate-x": "50%",
    "transform": "translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))",
    "backgroundColor": "transparent",
    "--tw-shadow": "0 0 #0000",
    "--tw-shadow-colored": "0 0 #0000",
    "boxShadow": "var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)",
    "@media (min-width: 1024px)": {
      "bottom": "6rem",
      "right": "6rem",
      "minWidth": "fit-content",
      "--tw-translate-x": "0px",
      "transform": "translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))"
    }
  } : {};
});

var IconWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "toastprimary__IconWrapper",
  componentId: "sc-1anczyn-1"
})({
  "display": "inline-flex",
  "height": "2rem",
  "width": "2rem",
  "flexShrink": "0",
  "alignItems": "center",
  "justifyContent": "center",
  "borderRadius": "0.5rem"
});

var CheckIconStyled = /*#__PURE__*/_styled(CheckIcon).withConfig({
  displayName: "toastprimary__CheckIconStyled",
  componentId: "sc-1anczyn-2"
})({
  "height": "1.25rem",
  "width": "1.25rem"
});

var ToastMessage = /*#__PURE__*/_styled.div.withConfig({
  displayName: "toastprimary__ToastMessage",
  componentId: "sc-1anczyn-3"
})({
  "marginLeft": "0.75rem",
  "fontSize": "0.875rem",
  "lineHeight": "1.25rem",
  "fontWeight": "400"
});

export var typeStyleMap = {
  success: {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(176 213 196 / var(--tw-bg-opacity))",
    "--tw-text-opacity": "1",
    "color": "rgb(0 119 64 / var(--tw-text-opacity))"
  },
  fail: {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(239 176 186 / var(--tw-bg-opacity))",
    "--tw-text-opacity": "1",
    "color": "rgb(204 0 34 / var(--tw-text-opacity))"
  },
  info: {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(225 239 254 / var(--tw-bg-opacity))",
    "--tw-text-opacity": "1",
    "color": "rgb(63 131 248 / var(--tw-text-opacity))"
  },
  warning: {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(253 246 178 / var(--tw-bg-opacity))",
    "--tw-text-opacity": "1",
    "color": "rgb(194 120 3 / var(--tw-text-opacity))"
  }
};